import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        {/* Left */}

        <div className="footer-left">
          <div className="footer-logo">
            <a href="/">
              <img
                src="/assets/Tns-logo.svg"
                alt="TNS Global"
                className="footer-logo-tns"
              />
            </a>

            <img
              src="/assets/Sabre-logo-footer.svg"
              alt="Sabre"
              className="footer-logo-sabre"
            />
          </div>

          <div className="footer-social">
            <a
              href="https://www.linkedin.com/company/106948931/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/newlink.svg" alt="LinkedIn" />
            </a>

            <a
              href="https://www.facebook.com/people/TNS-Global/61579914372332/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/fb.svg" alt="Facebook" />
            </a>

            <a
              href="https://www.instagram.com/tnsglobal_sabre/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/insta.svg" alt="Instagram" />
           
            </a>
          </div>
        </div>

        {/* Center */}

        <div className="footer-center">
          <a href="/">Home</a>

          <a href="/why-tns-sabre">Why TNS &amp; Sabre</a>

          <a href="/resources">Resources</a>

          <a href="/contact-us">Contact</a>
        </div>

        {/* Right */}

        <div className="footer-right">
          <div className="footer-contact">
            <img src="/assets/footer-location.svg" alt="Location" />

            <div>
              <h4>Office Address</h4>

              <p>
                TNS Global Headquarters 10th Floor, Crescent Towers, Nairobi
                Business District, Nairobi, Kenya
              </p>
            </div>
          </div>

          <div className="footer-contact">
            <img src="/assets/footer-mail.svg" alt="Email" />

            <div>
              <h4>Email</h4>

              <a href="mailto:connect@tnsglobal.co">connect@tnsglobal.co</a>
            </div>
          </div>

          <div className="footer-contact">
            <img src="/assets/footer-phn.svg" alt="Phone" />

            <div>
              <h4>Phone</h4>

              <a href="tel:+9710586279149">971-058-627-9149</a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 TNS Global. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
